module.exports = __webpack_public_path__ + "static/Poltergeist-ae7163443c45420fad2eab1901a876b8.jpg";